import { render, staticRenderFns } from "./LastTenRuns.vue?vue&type=template&id=f61a6018&scoped=true&"
import script from "./LastTenRuns.vue?vue&type=script&lang=js&"
export * from "./LastTenRuns.vue?vue&type=script&lang=js&"
import style0 from "./LastTenRuns.vue?vue&type=style&index=0&id=f61a6018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61a6018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
